import { Phone } from "lucide-react";
import { SITE, NAV } from "../../lib/site";

export const Footer = () => {
  return (
    <footer
      data-testid="site-footer"
      className="bg-brand-cream border-t border-border"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <div className="label-eyebrow text-brand-terracotta mb-4">Let&apos;s talk</div>
            <h2 className="font-display text-5xl sm:text-6xl lg:text-7xl tracking-tighter font-medium text-brand-ink leading-[0.95]">
              Your legacy <br />
              <span className="text-brand-terracotta italic font-normal">starts with a call.</span>
            </h2>
            <a
              href={SITE.phoneTel}
              data-testid="footer-call-button"
              className="mt-10 inline-flex items-center gap-3 group"
            >
              <span className="h-14 w-14 rounded-full bg-brand-eucalyptus text-brand-cream grid place-items-center group-hover:bg-brand-terracotta transition-colors">
                <Phone className="h-5 w-5" strokeWidth={1.8} />
              </span>
              <span className="font-display text-3xl sm:text-4xl text-brand-ink group-hover:text-brand-terracotta transition-colors">
                {SITE.phone}
              </span>
            </a>
          </div>

          <div className="lg:col-span-2 lg:col-start-9">
            <div className="label-eyebrow text-brand-ink/50 mb-5">Explore</div>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.href}>
                  <a
                    href={n.href}
                    data-testid={`footer-nav-${n.label.toLowerCase()}`}
                    className="text-sm text-brand-ink/75 hover:text-brand-terracotta transition-colors"
                  >
                    {n.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="label-eyebrow text-brand-ink/50 mb-5">Contact</div>
            <ul className="space-y-3 text-sm text-brand-ink/75">
              <li>
                <a
                  href={SITE.phoneTel}
                  data-testid="footer-phone-link"
                  className="hover:text-brand-terracotta transition-colors"
                >
                  {SITE.phone}
                </a>
              </li>
              <li>
                <a
                  href={SITE.emailHref}
                  data-testid="footer-email-link"
                  className="hover:text-brand-terracotta transition-colors break-all"
                >
                  {SITE.email}
                </a>
              </li>
              <li>{SITE.region}</li>
              <li className="text-brand-ink/50">Mon – Fri · 9am – 6pm AEST</li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-border space-y-6">
          <div
            data-testid="footer-disclaimer"
            className="text-xs text-brand-ink/55 leading-relaxed space-y-3 max-w-5xl"
          >
            <p>
              Credit Representative 569203 is authorised under Australian Credit
              Licence 389087.
            </p>
            <p>
              This website provides general information only and has been
              prepared without taking into account your objectives, financial
              situation or needs. We recommend that you consider whether it is
              appropriate for your circumstances and your full financial
              situation will need to be reviewed prior to acceptance of any
              offer or product. It does not constitute legal, tax or financial
              advice and you should always seek professional advice in relation
              to your individual circumstances.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 text-xs text-brand-ink/50">
            <div>© {new Date().getFullYear()} {SITE.name}. All rights reserved.</div>
          </div>
        </div>
      </div>
    </footer>
  );
};
